// Copyright 2022 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.

import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import { UserMselRole } from 'src/app/generated/blueprint.api';
import { Injectable } from '@angular/core';

export interface UserMselRoleState extends EntityState<UserMselRole> {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'userMselRoles' })
export class UserMselRoleStore extends EntityStore<UserMselRoleState> {
  constructor() {
    super();
  }
}
